import { connect } from 'react-redux';
import CustomPreviewPanel from './custom_preview_panel';
import { automaticPreview } from '../../selectors/preview';
import { setCrop, resetCrop } from '../../actions/crop';
import { closePanel } from '../../actions/panel';

const mapStateToProps = (state) => {
  const { crop } = state;
  return {
    ...crop,
    automaticPreview: automaticPreview(state)
  };
};

export default connect(mapStateToProps, {
  closePanel, setCrop, resetCrop
})(CustomPreviewPanel);
